import { supportEmail } from './site';

/** A mailto: link to support, optionally with a subject and body filled in. */
export function supportMailto(subject?: string, body?: string): string {
  const params = new URLSearchParams();
  if (subject) params.set('subject', subject);
  if (body) params.set('body', body);
  // URLSearchParams encodes spaces as "+", which mail apps show literally.
  const query = params.toString().replace(/\+/g, '%20');
  return `mailto:${supportEmail()}${query ? `?${query}` : ''}`;
}
